'use client'

import { AuthDialogModal } from '@/components/AuthDialogModal'

interface BetaSignUpModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function BetaSignUpModal({ open, onOpenChange }: BetaSignUpModalProps) {
  return (
    <AuthDialogModal
      open={open}
      onOpenChange={onOpenChange}
      title="Welcome to the team!"
      description="Create an account to save your progress and watchlist."
      authPath="sign-up"
      redirectTo="/auth-redirect"
    />
  )
}

